import React from 'react';
import ReactDOM from 'react-dom';
import {pin_state} from '../../../peripheral'
import {get_version, x2xxPlats, m33Plats} from '../../../../../../utes/appUtils';
import './matrix-cell.css'
class MatrixCell extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            value: this.props.value
        };
    }

    onClick(e) {
        if (this.props.value !== pin_state.DISABLED){
            this.props.matrix.setCell(e.target.selectionStart, this.props.x, this.props.y);
        }
    }

    focus() {
        var node = ReactDOM.findDOMNode(this);
        node.focus();
    }

    componentDidMount() {
        if(this.props.active) this.focus()
    }

    componentDidUpdate() {
        if(this.props.active) this.focus()
    }

    render() {
        let style;
        let fill = '';
        let className = 'pin-cell';
        if (this.props.type !== 'pinMap') {
            if (this.props.type === 'pullup') {
                fill = (this.props.value === 1) ? (
                        <span className="glyphicon glyphicon-arrow-up"/>
                    ) : ''
            }
            let backgroundColor;
            let outline = 'None';

            switch(this.props.value) {
                case pin_state.DISABLED:
                    backgroundColor = '#a7a7a7';
                    break;
                case pin_state.AVAILABLE:
                    backgroundColor = '#99ebff';
                    break;
                case pin_state.FIXED:
                    outline ='2px solid black';
                    backgroundColor = '#558ab2';
                    break;
                case pin_state.SELECTED:
                    backgroundColor = '#558ab2';
                    break;
                case pin_state.IN_USE:
                    backgroundColor = 'pink';
                    break;
                case pin_state.GPIO_INPUT:
                    backgroundColor = '#558ab2';
                    let benign_boot = -1;

                    if (x2xxPlats.includes(get_version(this.props.selectedBoard))) {
                        benign_boot = 32
                    } else if (m33Plats.includes(get_version(this.props.selectedBoard))) {
                        benign_boot = 25;
                    }

                    if ([benign_boot].includes(this.props.p_pin)) {
                        outline ='2px solid #ffc107';
                    }
                    fill = (
                        <div className={'io-style'}>
                            I
                        </div>
                    );
                    break;
                case pin_state.GPIO_OUTPUT:
                    backgroundColor = '#558ab2';
                    let warning_pins = [];


                    if (x2xxPlats.includes(get_version(this.props.selectedBoard))) {
                        warning_pins = [3,4,5,6,7,8,9,32];
                    } else if (m33Plats.includes(get_version(this.props.selectedBoard))) {
                        warning_pins = [25];
                    }

                    if (warning_pins.includes(this.props.p_pin)){
                        outline ='2px solid #ffc107';
                    }
                    fill = (
                        <div className={'io-style'}>
                            O
                        </div>
                    );
                    break;
                default:
                    backgroundColor = '#d8d8d8';
            }
            style = {
                // border: `2px solid ${borderColor}`,
                backgroundColor: backgroundColor,
                outline: outline
            };
        } else {
            fill = "P"+this.props.value;
            let stateOfPin = this.props.pinStatus[this.props.value];
            className = 'pinmap-pin';
            className +=((stateOfPin !== -1)&&(stateOfPin!==null))?'-active':'';
        }

        let title = "";
        if (this.props.selectedBoard !== undefined) {
            if (m33Plats.includes(get_version(this.props.selectedBoard))) {
                if ([pin_state.GPIO_INPUT,pin_state.GPIO_OUTPUT].includes(this.props.value) && this.props.p_pin === 25) {
                    title = 'Warning: P25 must be low for benign boot';
                }
            } else if (x2xxPlats.includes(get_version(this.props.selectedBoard))){
                if ([pin_state.GPIO_INPUT,pin_state.GPIO_OUTPUT].includes(this.props.value) && this.props.p_pin === 32) {
                    title = 'Warning: P32 must be low for benign boot';
                }
            }
        }

        return (
            <div ref="input" style={style}
                 title={title}
                 className={className}
                 onClick={this.onClick.bind(this)}
            >
                {fill}
            </div>
        );
    }
}
export default MatrixCell;
